import PropTypes from 'prop-types';
import cx from "ramda-extension/es/cx";
import React from 'react';
import constant from '../../../utils/constant';
import { useDefaultComponentValue } from '../../../utils/useDefaultComponentValue';
const COMPONENT_NAME = 'ProgressIndicator';
export const typeConstants = constant({
    INFO: 'Progress-bar--typeInfo',
    WARN: 'Progress-bar--typeWarning',
    ERROR: 'Progress-bar--typeError',
    SUCCESS: 'Progress-bar--typeSuccess'
});
const addPercentage = (value)=>`${value}%`;
const ProgressIndicator = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { className, type, percentage, displayPercentage, ...other } = props;
    return /*#__PURE__*/ React.createElement("span", {
        className: cx('Progress-bar', type, className),
        style: {
            width: addPercentage(percentage)
        },
        ...other
    }, displayPercentage ? addPercentage(percentage) : null);
};
ProgressIndicator.propTypes = {
    /**
	 * Custom `className` for the root.
	 */ className: PropTypes.string,
    /**
	 * If true, percentage will be displayed
	 */ displayPercentage: PropTypes.bool,
    /**
	 * Percentage
	 */ percentage: PropTypes.number,
    /**
	 * One of [INFO, WARN, ERROR].
	 */ type: PropTypes.oneOf(typeConstants.values())
};
ProgressIndicator.type = typeConstants;
export default ProgressIndicator;
